<div class="m-content">
  <div class="row">
    <div class="col-sm-12">
      <div class="m-portlet m-portlet--full-height">
        <div class="m-portlet__body">
          <div class="hx-filters">
            <div class="filter">
              <small>{{ 'money-flow-report.shops' | transloco }}</small>
              <hx-store-select [(ngModel)]="params.storeIds" [multiple]="true" (selectChange)="getTypeFilter()"></hx-store-select>
            </div>

            <div class="filter">
              <small>{{ 'money-flow-report.data' | transloco }}</small>
              <hx-date-range-select [(ngModel)]="params.date" (selectChange)="getTypeFilter()"></hx-date-range-select>
            </div>

            <div class="filter">
              <small>{{ 'money-flow-report.displayType' | transloco }}</small>
              <ng-select [(ngModel)]="viewType" (change)="getTypeFilter()"
                         [items]="viewTypeOptions" [placeholder]="'money-flow-report.type' | transloco">
                <ng-template ng-label-tmp ng-option-tmp let-item="item">
                  <span>{{ ('viewType.' + item) | transloco }}</span>
                </ng-template>
              </ng-select>
            </div>
          </div>

          <br><br>
          <hx-loader [length]="list.length || listByStore.length" [isLoading]="isLoading.list"></hx-loader>

          <div [hidden]="list.length === 0 && viewType === ViewType.MERGED" class="row">
            <div [hidden]="list.length === 0" id="chartdivmerged" class="chartdiv"></div>
            <br>
            <br>
            <div [hidden]="list.length === 0" class="row m--margin-20">
              <div class="m_datatable m-datatable--va-top m-datatable m-datatable--default m-datatable--loaded m--margin-top-30 m--margin-bottom-30">
                <table class="m-datatable__table">
                  <thead class="m-datatable__head">
                  <tr class="m-datatable__row m-datatable__row--head">
                    <th class="m-datatable__cell">{{ 'money-flow-report.spendCategoryTitle' | transloco }}</th>
                    <th class="m-datatable__cell">{{ 'money-flow-report.total' | transloco }}</th>
                  </tr>
                  </thead>
                  <tbody class="m-datatable__body">
                  <ng-container *ngFor="let even = even;let i = index; let spending of spendings">
                    <tr class="m-datatable__row" [ngClass]="{ 'm-datatable__row--even': even}">
                      <td class="m-datatable__cell">
                        {{ spending.spendCategoryTitle | uiLabel }}
                      </td>
                      <td class="m-datatable__cell text-align-last-end" *ngIf="spending.spendCategoryCode">
                        <a [routerLink]="['/storage/spendings']"
                           [queryParams]="{dateFrom: params.date?.from, dateTo: params.date?.to, storeIds: params.storeIds.join(','), spendCategoryCode: spending.spendCategoryCode }">
                          {{ spending.total | moneyFormat }}
                        </a>
                      </td>
                      <td class="m-datatable__cell text-align-last-end" *ngIf="!spending.spendCategoryCode">
                        <a class="refund" (click)="showRefunds(spending)">
                          {{ (spending.total + spending.archiveTotal) | moneyFormat }}
                        </a>
                      </td>
                    </tr>
                  </ng-container>
                  </tbody>
                </table>
              </div>
              <div class="m--margin-left-20">
                <div class="m_datatable m-datatable--va-top m-datatable m-datatable--default m-datatable--loaded m--margin-top-30 m--margin-bottom-30">
                  <table class="m-datatable__table">
                    <tbody class="m-datatable__body">
                    <tr class="m-datatable__row">
                      <td class="m-datatable__cell color-gray">{{ 'money-flow-report.ts.sale' | transloco }}</td>
                      <td class="m-datatable__cell text-align-last-end">{{ totalSpendingInfo?.totalRevenues | moneyFormat }}</td>
                    </tr>
                    <tr class="m-datatable__row">
                      <td class="m-datatable__cell color-gray">{{ 'money-flow-report.ts.expenses' | transloco }}</td>
                      <td class="m-datatable__cell text-align-last-end">{{ totalSpendingInfo?.totalSpends | moneyFormat }}</td>
                    </tr>
                    <tr class="m-datatable__row">
                      <td class="m-datatable__cell color-gray">{{ 'money-flow-report.ts.profit' | transloco }}</td>
                      <td class="m-datatable__cell text-align-last-end">{{ totalSpendingInfo?.totalSales | moneyFormat }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <br>
              <br>
            </div>
          </div>

          <div *ngIf="viewType === ViewType.SPLIT && this.listByStore.length">
            <div *ngFor="let i = index; let item of stores" class="row">
              <br>
              <span style="padding-left: 30px; font-weight: bold">{{ item.title | uiLabel }}</span>
              <div [id]="'chartdivsplit_' + item.id" class="chartdiv"></div>
              <br>
              <br>
              <div class="row m--margin-20">
                <div class="m_datatable m-datatable--va-top m-datatable m-datatable--default m-datatable--loaded m--margin-top-30 m--margin-bottom-30">
                  <div class="m--margin-bottom-15">
                    <span class="store-info">{{ 'money-flow-report.store' | transloco }}:</span> {{ item.title | uiLabel }} <span class="store-info">{{ 'money-flow-report.data' | transloco }}:</span> {{ params.date.from | date: 'dd.MM.yyyy' }} - {{ params.date.to | date: 'dd.MM.yyyy' }}
                  </div>
                  <table class="m-datatable__table">
                    <thead class="m-datatable__head">
                    <tr class="m-datatable__row m-datatable__row--head">
                      <th class="m-datatable__cell">{{ 'money-flow-report.spendCategoryTitle' | transloco }}</th>
                      <th class="m-datatable__cell">{{ 'money-flow-report.total' | transloco }}</th>
                    </tr>
                    </thead>
                    <tbody class="m-datatable__body">
                    <ng-container *ngFor="let even = even;let i = index; let spending of spendingMap.get(item.id)">
                      <tr class="m-datatable__row" [ngClass]="{ 'm-datatable__row--even': even}">
                        <td class="m-datatable__cell">
                          {{ spending.spendCategoryTitle | uiLabel }}
                        </td>
                        <td class="m-datatable__cell text-align-last-end" *ngIf="spending.spendCategoryCode">
                          <a [routerLink]="['/storage/spendings']"
                             [queryParams]="{dateFrom: params.date?.from, dateTo: params.date?.to, storeIds: [spending.storeId], spendCategoryCode: spending.spendCategoryCode }">
                            {{ spending.total | moneyFormat }}
                          </a>
                        </td>
                        <td class="m-datatable__cell text-align-last-end" *ngIf="!spending.spendCategoryCode">
                          <a class="refund" (click)="showRefunds(spending)">
                            {{ (spending.total + spending.archiveTotal) | moneyFormat }}
                          </a>
                        </td>
                      </tr>
                    </ng-container>
                    </tbody>
                  </table>
                </div>
                <div class="m--margin-35">
                  <div class="m_datatable m-datatable--va-top m-datatable m-datatable--default m-datatable--loaded m--margin-top-30 m--margin-bottom-30">
                    <table class="m-datatable__table">
                      <tbody class="m-datatable__body">
                      <tr class="m-datatable__row">
                        <td class="m-datatable__cell color-gray">{{ 'money-flow-report.ts.sale' | transloco }}</td>
                        <td class="m-datatable__cell text-align-last-end">{{ totalSpendingMap.get(item.id)?.totalRevenues | moneyFormat }}</td>
                      </tr>
                      <tr class="m-datatable__row">
                        <td class="m-datatable__cell color-gray">{{ 'money-flow-report.ts.expenses' | transloco }}</td>
                        <td class="m-datatable__cell text-align-last-end">{{ totalSpendingMap.get(item.id)?.totalSpends | moneyFormat }}</td>
                      </tr>
                      <tr class="m-datatable__row">
                        <td class="m-datatable__cell color-gray">{{ 'money-flow-report.ts.profit' | transloco }}</td>
                        <td class="m-datatable__cell text-align-last-end">{{ totalSpendingMap.get(item.id)?.totalSales | moneyFormat }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              <br>
              <br>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #templateRef let-modal>
  <div class="m_datatable m-datatable--va-top m-datatable m-datatable--default m-datatable--loaded m--margin-top-30 m--margin-bottom-30 m--margin-left-20 m--margin-right-20">
    <table class="m-datatable__table">
      <thead class="m-datatable__head">
      <tr class="m-datatable__row m-datatable__row--head">
        <th class="m-datatable__cell">{{ 'money-flow-report.spendCategoryTitle' | transloco }}</th>
        <th class="m-datatable__cell">{{ 'money-flow-report.total' | transloco }}</th>
      </tr>
      </thead>
      <tbody class="m-datatable__body">
        <tr class="m-datatable__row" *ngIf="selected.total > 0">
          <td class="m-datatable__cell">
            {{ selected.spendCategoryTitle | uiLabel }}
          </td>
          <td class="m-datatable__cell">
            <a (click)="modal.dismiss()" [routerLink]="['/orders/list']"
               [queryParams]="{dateFrom: params.date?.from, dateTo: params.date?.to, storeId: selected.storeId, actions: refundAction }">
              {{ selected.total | moneyFormat }}
            </a>
          </td>
        </tr>
        <tr class="m-datatable__row" *ngIf="selected.archiveTotal > 0">
          <td class="m-datatable__cell">
            {{ selected.spendCategoryTitle | uiLabel }} {{ 'money-flow-report.archive' | transloco }}
          </td>
          <td class="m-datatable__cell">
            <a (click)="modal.dismiss()" [routerLink]="['/orders/archive']"
               [queryParams]="{dateFrom: params.date?.from, dateTo: params.date?.to, storeId: selected.storeId, actions: refundAction }">
              {{ selected.archiveTotal | moneyFormat }}
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">{{ 'user-list.btn.close' | transloco }}</button>
  </div>
</ng-template>
